export enum ViewType {
    NONE,
    RECON,
    GENERAL
}
